import React from "react";
import { connect } from "react-redux";
import { selectProfile } from "./selectors";
import { getProfile } from "./actions";
import { Card, CardContent, CardHeader, Grid, Typography, Avatar } from "@material-ui/core";
class Profile extends React.Component {
    constructor(props) {
        super(props);

        props.getProfile();
    }

    render() {
        let profile = this.props.profile === false ? false : this.props.profile;
        return (
            <Card>
                <CardHeader title="User Profile" />
                <CardContent>
                    {profile && (
                        <Grid container spacing={40}>
                            <Grid item xs={6} xl={6}>
                                <Avatar
                                    alt="profile avatar"
                                    src={profile.profile_image_url}
                                    style={{ height: "auto", width: "50%", margin: "auto" }}
                                />
                            </Grid>
                            <Grid style={{ textAlign: "center" }} item xs={6} xl={6}>
                                <Typography style={{ marginBottom: "10px" }} variant="title">
                                    Security Level:
                                </Typography>
                                <Typography style={{ marginBottom: "40px" }} variant="subheading">
                                    {profile.security_level}
                                </Typography>

                                <Typography style={{ marginBottom: "10px" }} variant="title">
                                    Access Level:
                                </Typography>
                                <Typography variant="subheading">{profile.access_level}</Typography>
                            </Grid>
                            <Grid style={{ textAlign: "center" }} item xs={6} xl={6}>
                                <Typography style={{ marginBottom: "10px" }} variant="title">
                                    Name:
                                </Typography>
                                <Typography style={{ marginBottom: "40px" }} variant="subheading">
                                    {profile.first_name} {profile.last_name}
                                </Typography>

                                <Typography style={{ marginBottom: "10px" }} variant="title">
                                    Email:
                                </Typography>
                                <Typography variant="subheading">{profile.email}</Typography>
                            </Grid>
                            <Grid style={{ textAlign: "center" }} item xs={6} xl={6}>
                                <Typography style={{ marginBottom: "10px" }} variant="title">
                                    Account Created:
                                </Typography>
                                <Typography style={{ marginBottom: "40px" }} variant="subheading">
                                    {profile.account_created}
                                </Typography>

                                <Typography style={{ marginBottom: "10px" }} variant="title">
                                    Last Active:
                                </Typography>
                                <Typography variant="subheading">{profile.last_active}</Typography>
                            </Grid>
                        </Grid>
                    )}
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return { profile: selectProfile(store) };
    },
    { getProfile }
)(Profile);
